import Dbm from "dbm";
import Website from "../../../index.js";

export default class ScoreDisplay extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let margin = 10;

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        container.position.x = Website.game.Sizes.WIDTH-margin;
        container.position.y = margin;
        
        this.item.setValue("score", 0);
        this.item.setValue("text", "TILLVÄXTPOÄNG");
        this.item.setValue("highscoreEnvelope", 0);

        let text = Dbm.getRepositoryItem("game").controller.getText(this.item.text + " " + "0");

        text.anchor.set(1, 0);

        container.addChild(text);
        this.item.setValue("textElement", text);
    }

    updateScore(aNewScore) {
        this.item.properties.score.animateValue(aNewScore, 0.4);
    }

    showHighscore() {
        let halfFlashTime = 0.2;
        this.item.properties.highscoreEnvelope.animateValue(1, halfFlashTime);
        this.item.properties.highscoreEnvelope.addAddionalAnimation(1, 0, halfFlashTime, 1*halfFlashTime);
        this.item.properties.highscoreEnvelope.addAddionalAnimation(0, 1, halfFlashTime, 2*halfFlashTime);
        this.item.properties.highscoreEnvelope.addAddionalAnimation(1, 0, halfFlashTime, 3*halfFlashTime);

        this.item.text = "HIGH SCORE";
        this.item.properties.text.delayValue("TILLVÄXTPOÄNG", 4*halfFlashTime+0.7);
    }

    updateText() {
        let roundedScore = Math.round(this.item.score);
        this.item.textElement.text = this.item.text + " " + roundedScore;
    }

    update(aTime, aDelta) {
        //console.log("update");

        this.updateText();

        let highscoreEnvelope = this.item.highscoreEnvelope;

        let scale = (1-highscoreEnvelope)*1+(highscoreEnvelope)*1.2;
        this.item.pixiLayer.scale.set(scale);

        const r = 255;
        const g = Math.round(255 * (1 - highscoreEnvelope));
        const b = Math.round(255 * (1 - highscoreEnvelope));

        this.item.textElement.style.fill = (r << 16) | (g << 8) | b;
    }
}